export const DECIMAL_SEPARATOR = '.' as const;
export const THOUSAND_SEPARATOR = ' ' as const;
export const DECIMAL_SCALE = 4 as const;
